import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BookReadingClass from "../pages/book-reading-class/page";
import LevelTestRegistration from "../pages/level-test-registration/page";
import FocusWritingClass from "../pages/focus-writing-class/page";
import EnglishForAdults from "../pages/english-for-adults/page";
import Layout from "../components/feature/Layout";

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'book-reading-class',
        element: <BookReadingClass />,
      },
      {
        path: 'focus-writing-class',
        element: <FocusWritingClass />,
      },
      {
        path: 'english-for-adults',
        element: <EnglishForAdults />,
      },
      {
        path: 'level-test-registration',
        element: <LevelTestRegistration />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;
